import { makeVar } from "@apollo/client";

import { ProductCategoryOptionType } from "./types";

export const productCategoryOptions = makeVar<
  ProductCategoryOptionType[] | undefined
>(undefined);
